




import React, { useEffect, useState } from "react";
import "./DhonusdhariStartingComponent.css";
import GaneshImg from "../../assets/ganesh.png";
import logo from "../../assets/dhanushdhari_final_log.jpeg";
import { motion,AnimatePresence  } from "framer-motion";
import { Phone, Mail, MessageCircle } from "lucide-react";

const Dhanusdhari = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hovered, setHovered] = useState(null);
    // const [hovered, setHovered] = useState(null);

  const contactItems = [
    { id: "phone", icon: <Phone size={22} />, label: "Call Now", link: "tel:+910000000000" },
    { id: "mail", icon: <Mail size={22} />, label: "Email Us", link: "mailto:info@Dhanusdhari.com" },
    { id: "whatsapp", icon: <MessageCircle size={22} />, label: "WhatsApp Now", link: "https://wa.me/910000000000" },
  ];

  useEffect(() => {
    const img = document.querySelector(".ganesh-image");
    const chakra = document.querySelector(".chakra");
    const title = document.querySelector(".title");

    setTimeout(() => {
      img.classList.add("scale-down");
      setTimeout(() => {
        chakra.classList.add("chakra-visible");
        setTimeout(() => {
          title.classList.add("title-visible");
        }, 900);
      }, 1800);
    }, 100);
  }, []);

  return (
    <div className="Dhanusdhari-body">
      {/* 🟡 Logo */}
      <div className="dhannus-logo-container">
        <img src={logo} alt="Dhannus Logo" className="dhannus-logo" />
      </div>

      {/* 🕉️ Main Content */}
      <div className="container">
        <div className="image-container">
          <div className="chakra"></div>
          <img src={GaneshImg} alt="Ganesh" className="ganesh-image" />
        </div>
        <div className="title-container">
          <h1 className="title">Dhanushdhari</h1>
        </div>
      </div>

 <div className="dhannusContactIcons-container">
      {contactItems.map((item) => (
        <div
          key={item.id}
          className="dhannusContactIcons-iconWrapper"
          onMouseEnter={() => setHovered(item.id)}
          onMouseLeave={() => setHovered(null)}
        >
          <a
            href={item.link}
            target={item.id === "whatsapp" ? "_blank" : "_self"}
            rel="noopener noreferrer"
            className="dhannusContactIcons-icon"
          >
            {item.icon}
          </a>

          <AnimatePresence>
            {hovered === item.id && (
              <motion.div
                className="dhannusContactIcons-tooltip"
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 40 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
              >
                {item.label}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>

      {/* Akash Drawer */}

      {/* <div className="conact_drawer_parrent">
        <div className="Phone_div">
          
        </div>
        <div>Email</div>
        <div>Whatsapp</div>
      </div> */}
    </div>
  );
};

export default Dhanusdhari;
